import Vue from 'vue'
import Router from 'vue-router'
import base from '../components/subcomponents/base.vue'
import usersPage from '../components/users/users.vue'
import commonRoutes from '../../common/router/index'

Vue.use(Router)

var ugRoutes = [
    {
        path: '/',
        name: base,
        component: base
    },
    {
        path: '/users',
        name: usersPage,
        component: usersPage
    }];

export default new Router({
    routes: [...ugRoutes, ...commonRoutes]
});